/* eslint-disable import/prefer-default-export */

import { LogPostData } from '../components/dashboard/LogPost/types';

export const getFileExtentionFromLink = (link: string) => {
  const d = link.split('.');
  if (d[d.length - 1].includes('%')) {
    return d[d.length - 1].split('%')[0];
  }
  return d[d.length - 1];
};

export const formatCurrency = (currencyAmount: number, currencyCode: string) => {
  if (!currencyAmount) return '0';
  const formattedCurrency = currencyAmount.toLocaleString('en-US', { style: 'currency', currency: currencyCode });
  return formattedCurrency;
};

export const isValidUrl = (urlData: string) => {
  try {
    const url = new URL(urlData);
    return url;
  } catch (error) {
    return false;
  }
};

export const stripeURL = (url: string) => {
  const strippedUrl = url.replace(/<\/?[^>]+(>|$)/g, '');
  const lowerCasedUrl = strippedUrl.toLowerCase();
  const UrlData = isValidUrl(lowerCasedUrl);
  if (UrlData) {
    return UrlData?.pathname.slice(1);
  }
  return lowerCasedUrl;
};

export const getDateNDaysAgo = (numOfDays: number, date = new Date()) => {
  const daysAgo = new Date(date.getTime());
  daysAgo.setDate(date.getDate() - numOfDays);
  return daysAgo;
};

export const getDateNDaysAhead = (numOfDays: number, date = new Date()) => {
  const daysAgo = new Date(date.getTime());
  daysAgo.setDate(date.getDate() + numOfDays);
  return daysAgo;
};

export const hasQueryParams = (url: string) => {
  const { searchParams } = new URL(url);
  return searchParams && searchParams.toString().trim() !== '';
};

export const formatRefLink = (refLink: string, refCode: string, platform: string, userName: string) => {
  const newRefLink = refLink?.includes('http') ? refLink?.split('//')[1] : refLink;
  const hasQueryParam = refLink ? hasQueryParams(`https://${refLink}`) : false;
  let displayRefLink = '';
  if (hasQueryParam) {
    displayRefLink = newRefLink;
  } else {
    displayRefLink = `${newRefLink}?ref=${refCode}`;
  }
  if (displayRefLink?.includes('{{platform}}') || displayRefLink?.includes('{{username}}')) {
    displayRefLink = displayRefLink
      .replaceAll('{{platform}}', platform || '')
      .replaceAll('{{username}}', userName || '');
  }

  return displayRefLink;
};

export const getCurrencyLogo = (currencyCode: string) => {
  const currencySymbols: { [key: string]: string } = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    AUD: 'A$',
    CAD: 'C$',
    CHF: 'Fr',
    CNY: '¥',
    SEK: 'kr',
    NZD: 'NZ$',
    INR: '₹',
  };
  if (currencyCode in currencySymbols) {
    return currencySymbols[currencyCode];
  }
  return currencyCode;
};

export const reverseLogPosts = (logPosts: LogPostData) => {
  const reversedKeys = Object.keys(logPosts).reverse();

  const newObject: LogPostData = {};
  reversedKeys.forEach((k) => {
    newObject[k] = logPosts[k];
  });

  return newObject;
};
